import gsap from 'gsap'

export default function bgTextAnimation() {
  const SPEED_FACTOR = 0.1
  const STOP_DISTANCE_PX = 1

  let current = 0
  let target = 0
  let isMoving = false
  let directionIsDownwards = true
  const callbacks = []
  // eslint-disable-next-line func-names
  const runCallbacks = function() {
    // eslint-disable-next-line prefer-rest-params
    callbacks.forEach(cb => cb(...arguments))
  }
  const animationFrame = () => {
    target = window.scrollY || document.documentElement.scrollTop
    const diff = Math.abs(current - target)

    if (diff >= STOP_DISTANCE_PX) {
      isMoving = true
      directionIsDownwards = target > current
      current += SPEED_FACTOR * (target - current)
    } else if (diff < STOP_DISTANCE_PX && isMoving) {
      isMoving = false
      directionIsDownwards = target > current
      current = target
    }
    runCallbacks({ currentScroll: current, directionIsDownwards })
  }

  const LOOPED_TEXTS_COUNT = 2 // choose any number from 2 to 100 so that total width of repeated texts is more than window width
  const IDLE_SPEED_PX_PER_FRAME = 1

  const bgWordsElements = document.querySelectorAll('[data-bg-words]')
  bgWordsElements.forEach(bgWords => {
    const text = bgWords.textContent
    bgWords.textContent = ''
    bgWords.style.display = 'flex'
    for (let i = 0; i < LOOPED_TEXTS_COUNT; i++) {
      const div = document.createElement('div')
      div.textContent = text
      div.style.willChange = 'transform'
      bgWords.appendChild(div)
    }
  })
  // hook up to smooth scroll's request animation frame
  // and introduce the time
  let time = 0
  // eslint-disable-next-line no-shadow
  callbacks.push(({ currentScroll, directionIsDownwards }) => {
    if (directionIsDownwards) {
      time += 1
    } else {
      time -= 1
    }
    bgWordsElements.forEach(bgWords => {
      const singleItemLength = bgWords.clientWidth / LOOPED_TEXTS_COUNT
      if (time <= 0) {
        time += singleItemLength
      }
      const position =
        (currentScroll + IDLE_SPEED_PX_PER_FRAME * time) % singleItemLength
      for (let i = 0; i < LOOPED_TEXTS_COUNT; i++) {
        bgWords.children[i].style.transform = `translate(${position}px, 0)`
      }
    })
  })

  gsap.ticker.add(animationFrame)

  return animationFrame
}
